import Table from 'components/Table/Table';
import { createColumnHelper } from '@tanstack/react-table';
import moment from 'moment';
import { UserConnection } from 'services/auth/auth.types';
import { useConnections } from './useConnectionsVM';
import { userRoleFormatter } from 'utils/enumFormatter';
export const Connections: React.FunctionComponent = () => {

    const {
        connections,
        isGetAllConnectionsLoading
    } = useConnections();

    const columnHelper = createColumnHelper<UserConnection>();

    const tableColumns = [
        columnHelper.accessor('firstname', {
            header: 'Prénom',
            cell: (info) => <i>{info.getValue()}</i>,
            footer: (info) => info.column.id
        }),
        columnHelper.accessor('lastname', {
            header: 'Nom',
            cell: (info) => <i>{info.getValue()}</i>,
            footer: (info) => info.column.id
        }),
        columnHelper.accessor('role', {
            header: 'Rôle',
            cell: (info) => <i>{userRoleFormatter(info.getValue())}</i>,
            footer: (info) => info.column.id
        }),
        columnHelper.accessor('connected_at', {
            header: 'Connecté le',
            cell: (info) => <i>{moment(info.getValue()).format('DD/MM/YYYY HH:mm')}</i>,
            footer: (info) => info.column.id
        }),
    ];


    return (
        <>
            <main id="connections-list">
                <Table data={connections} columns={tableColumns} columnHelper={columnHelper} className="table-card" isLoading={isGetAllConnectionsLoading} />
            </main>

        </>
    );
};
